import React from "react";
import {
  PageList,
  ENUM_FORM_DISPLAY,
  ENUM_FORM_LAYOUT_CONTAINER,
} from "../components/pageList";
import { useCellRender } from "../hooks/useCellRender";
import ActionCellRender from "../components/actionCellRender";

import { IconTrash, IconPencil, IconSettings } from "@tabler/icons";

import { TextInput } from "@mantine/core";
import RemoteSelect2 from "../components/remoteSelect2";
import ProfolioFileImporter from "../components/profolioFileImporter";
import FileList from "../components/fileList";
import CommissionStatementTable from "../components/commissionStatementTable";
import ProfolioStat from "../components/profolioStat";
import ProfolioRowTable from "../components/profolioRowTable";
import ActivityLog from "../components/activityLog.js";
import AutoCodeInput from "../components/autoCodeInput";
import moment from "moment";
import { DatePicker } from "@mantine/dates";
import DataFeedImporter from "../components/dataFeedImporter";
import FormConfirmation from "../components/formConfirmation";
import DataFeedSummary from "../components/dataFeedSummary";
import dataTable from "../components/dataTable";
import DataFeedIssues from "../components/dataFeedIssues";

const apiEntity = "dataFeed";
const initialValues = {};

const addFormSchema = {
  title: "New DataFeed Import",
  display: {
    mode: ENUM_FORM_DISPLAY.MODAL,
    size: "xl", //xs, sm, xl  ....100%
  },
  showSaveBar: false,
  apiEntity,
  initialValues,
  validate: {},

  layout: {
    containers: [
      {
        key: "t1",
        parent: null,
        type: ENUM_FORM_LAYOUT_CONTAINER.WIZARD,
        props: {
          variant: "default", //default | pills | outline
          defaultValue: "Datafeed Info",
          orientation: "vertical",
          style: { minHeight: "400px" },
        },
        steps: [
          {
            key: "t1-1",
            label: "Datafeed Info",
            icon: IconSettings,
          },
          { key: "t1-2", label: "Import File", icon: IconSettings },

          { key: "t1-3", label: "Confirm", icon: IconSettings },
        ],
      },

      {
        key: "section-import",
        parent: "t1-2",
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "Import File",
          description: "Please upload the profolio file",
          withBorder: false,
          ml: 20,
          mt: 0,
        },
      },

      {
        key: "section-confirm",
        parent: "t1-3",
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "Confirm ",
          description: "Please confirm the details",
          withBorder: false,
          ml: 20,
          mt: 0,
        },
      },
    ],

    fields: [
      {
        name: "code",
        component: AutoCodeInput,
        parent: "t1-1",
        props: {
          required: true,
          placeholder: "",
          label: "Patch ID",
        },
      },

      {
        name: "receviedDate",
        parent: "t1-1",
        component: DatePicker,
        props: {
          label: "Received Date",
        },
      },
      {
        name: "remark",
        component: TextInput,
        parent: "t1-1",
        props: {
          placeholder: "",
          label: "Remark",
        },
      },
      {
        name: "rows",
        component: DataFeedImporter,
        parent: "section-import",
        props: {},
      },

      {
        name: "confirm",
        component: FormConfirmation,
        parent: "section-confirm",
        props: {},
      },
    ],
  },
};

const DataFeed = ({}) => {
  const [cellRender] = useCellRender();

  const tableSchema = {
    showActionColumn: true,
    select: "-rows",
    columns: [
      { field: "code", headerName: "Code", sortable: true },
      {
        field: "receviedDate",
        headerName: "Recevied Date",
        sortable: true,
        cellRender: (col, data) => moment(data.receviedDate).format("LL"),
      },
      {
        field: "totalRows",
        headerName: "Total Rows",
      },
      {
        field: "totalSuccess",
        headerName: "Total Success",
      },

      {
        field: "action",
        cellRender: ActionCellRender,
        isAction: true,
        actions: [
          {
            name: "edit",
            icon: IconPencil,
            props: {
              //   color:"red"
            },
          },
          {
            name: "delete",
            icon: IconTrash,
            props: {
              //   color:"red"
            },
          },
        ],
      },
    ],
  };

  const editFormSchema = {
    // title: "Commission Statement",
    titleField: "code",
    display: {
      mode: ENUM_FORM_DISPLAY.INSIDE,
      size: "xl", //xs, sm, xl  ....100%
      // position:"right"
    },
    apiEntity,
    initialValues,
    layout: {
      containers: [
        {
          key: "main-tab",
          parent: null,
          type: ENUM_FORM_LAYOUT_CONTAINER.TABS,
          props: {
            variant: "default", //default | pills | outline
            defaultValue: "Datafeed",
          },
          tab: [
            {
              key: "tab1",
              label: "Datafeed",
              icon: IconSettings,
            },

            {
              key: "tab4",
              label: "Issues",
              icon: IconSettings,
            },

            {
              key: "tab2",
              label: "Files",
              icon: IconSettings,
            },

            {
              key: "tab3",
              label: "Logs",
              icon: IconSettings,
            },
          ],
        },

        {
          key: "section-files",
          parent: "tab2",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Files",
            titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            minHeight: "0px",
            mt: 20,
            mb: 20,
          },
        },

        {
          key: "section-stat",
          parent: "tab1",
          type: ENUM_FORM_LAYOUT_CONTAINER.BOX,
          props: {
            mt: 50,
          },
        },

        {
          key: "section-rows",
          parent: "tab4",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Policy Not found",
            mt: 50,
          },
        },

        {
          key: "section-log",
          parent: "tab3",
          type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
          props: {
            title: "Log",
            titleOrder: 5,
            // description: "Please assign the corresponding consultant",
            withBorder: false,
            minHeight: 0,

            mt: 20,
            mb: 20,
          },
        },
      ],
      fields: [
        {
          name: "stats",
          parent: "section-stat",
          component: DataFeedSummary,
          props: {},
        },

        {
          name: "issues",
          component: DataFeedIssues,
          parent: "section-rows",
          props: {},
        },

        {
          name: "files",
          component: FileList,
          parent: "section-files",
          props: {},
        },

        {
          name: "logs",
          component: ActivityLog,
          parent: "section-log",
          props: {},
        },
      ],
    },
  };

  const formSchema = {
    add: addFormSchema,
    edit: editFormSchema,
  };

  return (
    <PageList
      title={"DataFeed"}
      apiEntity={apiEntity}
      tableSchema={tableSchema}
      formSchema={formSchema}
    />
  );
};

export default DataFeed;
